import { useState } from 'react'

import { parseBackendDate } from 'modules/core/components/DateNavigator/dateFormatUtils'
import DayPicker from 'modules/core/components/DayPicker'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { DayOfWeekIndex, dateToString } from 'modules/core/lib/dates'

type Props = {
  startDate: Date
  endDate: Date
  onDateRangeChange: (startDate: Date, endDate: Date) => void
  firstDayOfWeek: DayOfWeekIndex
}

export const RangePicker = ({ startDate, endDate, onDateRangeChange, firstDayOfWeek }: Props) => {
  const [temporalRange, setTemporalRange] = useState<[string | undefined, string | undefined]>(
    () => [dateToString(startDate, 'backend'), dateToString(endDate, 'backend')]
  )

  useUnsafeEffect(() => {
    setTemporalRange([dateToString(startDate, 'backend'), dateToString(endDate, 'backend')])
  }, [startDate, endDate])

  const handleOnDateRangeChange = useUnsafeCallback(
    (dateRange: [string | undefined, string | undefined]) => {
      setTemporalRange(dateRange)

      if (dateRange[0] && dateRange[1]) {
        onDateRangeChange(parseBackendDate(dateRange[0]), parseBackendDate(dateRange[1]))
      }
    },
    [onDateRangeChange]
  )

  return (
    <DayPicker
      mode="range"
      showOnlyCalendar
      value={temporalRange}
      onChange={handleOnDateRangeChange}
      firstDayOfWeek={firstDayOfWeek}
    />
  )
}
